// extracted by mini-css-extract-plugin
export var errorInput = "bg_dv";
export var errorLabel = "bg_dr";
export var inputContainer = "bg_dw";
export var inputNumber = "bg_dx";
export var inputPercentage = "bg_dy";
export var textInput = "bg_dz";
export var textInputDefault = "bg_dB";
export var textlabel = "bg_ds";